module.exports = __webpack_public_path__ + "img/ubereats.79669630.png";